import styled from 'styled-components';
import { BLACK, GRAYSCALE_300, PRIMARY } from '../../styles/colors';
import { INTER } from '../../styles/fonts';

export const CheckboxContainer = (styled.div`
    display: flex;
    align-items: center;
    margin: 0px;
    padding: 0 0px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const CheckboxInput = (styled.input.attrs({ type: 'checkbox' })`
    width: 20px;
    height: 20px;
    margin-right: 10px;
    border: 1px solid ${GRAYSCALE_300};
    border-radius: 4px;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: transparent;
    position: relative;

    &:checked {
        background-color: ${PRIMARY};
        border-color: ${PRIMARY};
    }

    &:checked:after {
        content: '';
        position: absolute;
        left: 6px;
        top: 2px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const CheckboxInputWrapper = (styled.div`
    display: flex;
    flex: 1;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const CheckboxLabel = (styled.label`
    font-family: ${INTER.regular};
    font-size: 12px;
    color: ${BLACK};
    cursor: pointer;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
